import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['48px', '48px'],
};

const MoreIcon = (props) => {
  const size = typeof props.size === 'string' ? sizes[props.size] : props.size;
  const [width, height] = size;

  const svgProps = {
    width,
    height,
    style: Object.assign(
      props.shouldPadding ? { padding: '4px' } : {},
      props.style
    ),
  };
  return (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      {...svgProps}
    >
      <circle
        cx={32}
        cy={32}
        r={7.16}
      />
      <circle
        cx={32.09}
        cy={11.91}
        r={7.16}
      />
      <circle
        cx={32.09}
        cy={52.09}
        r={7.16}
      />
    </svg>
  );
};
MoreIcon.propTypes = {
  size: PropTypes.string,
  shouldPadding: PropTypes.bool,
  style: PropTypes.object,
};
MoreIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
  style: {},
};

export default MoreIcon;
